"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const hooks_1 = require("../hooks");
const react_use_1 = require("react-use");
const hooks_2 = require("../../../hooks");
const AdminOnly_1 = require("../../../comps/reusables/AdminOnly");
const utils_1 = require("@osmosys/utils");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
exports.EmailCanvasEmailName = () => {
    const { state: { draftEmail: { emailNumber }, link, displayName, }, } = hooks_1.useEmailCanvasContext();
    const [state, copyToClipboard] = react_use_1.useCopyToClipboard();
    const fullLink = `${window.location.protocol}//${window.location.host}${link ? link() : ''}`;
    return (react_2.default.createElement(exports.Inner, { link: link, error: state.error, value: state.value, fullLink: fullLink, emailNumber: emailNumber, displayName: displayName, copyToClipboard: copyToClipboard }));
};
exports.Inner = ({ link, fullLink, value, error, copyToClipboard, displayName, emailNumber, }) => {
    return (react_2.default.createElement(react_router_dom_1.Link, { to: link ? link() : '', className: "text-reset", onClick: e => {
            if (e && e.preventDefault) {
                e.preventDefault();
            }
            copyToClipboard(fullLink);
        } },
        react_2.default.createElement(react_1.OsmosysTooltip, { label: ` ${!error && value
                ? `${fullLink} has been copied to your clipboard!`
                : `Click to copy the URL of Email #${emailNumber}`}`, span: true }, displayName),
        react_2.default.createElement(AdminOnly_1.AdminOnly, null,
            react_2.default.createElement(exports.ShowEmailQuery, null))));
};
exports.ShowEmailQuery = () => {
    const { featureFlags: { useNewLoaderForEmailQuery }, } = hooks_2.useOsmosysContext();
    return utils_1.isDefined(useNewLoaderForEmailQuery) ? (react_2.default.createElement("sup", null,
        react_2.default.createElement("small", null,
            react_2.default.createElement(react_1.OsmosysTooltip, { span: true, label: useNewLoaderForEmailQuery
                    ? 'Using new email query'
                    : 'Using old email query' },
                react_2.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faAsterisk, className: useNewLoaderForEmailQuery ? 'text-primary' : 'text-warning', size: "sm" }))))) : null;
};
//# sourceMappingURL=EmailName.js.map